import { render, staticRenderFns } from "./GroupSelectMember.vue?vue&type=template&id=24fc0982&scoped=true"
import script from "./GroupSelectMember.vue?vue&type=script&lang=js"
export * from "./GroupSelectMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc0982",
  null
  
)

export default component.exports